export const formatToDDMMYYYY = (dateString) => {
  if (!dateString) return 'N/A';
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'N/A';
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  
  return `${day}/${month}/${year}`;
};

// Convert dd/mm/yyyy to Date object for filtering
export const parseDDMMYYYY = (dateString) => {
  if (!dateString || dateString === 'all') return null;
  
  const parts = dateString.split('/');
  if (parts.length !== 3) return null;
  
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  
  return new Date(year, month, day);
};

// Convert HTML date input (yyyy-mm-dd) to dd/mm/yyyy
export const convertHTMLDateToDDMMYYYY = (htmlDate) => {
  if (!htmlDate || htmlDate === 'all') return 'all';
  
  const parts = htmlDate.split('-');
  if (parts.length !== 3) return 'all';
  
  const year = parts[0];
  const month = parts[1];
  const day = parts[2];
  
  return `${day}/${month}/${year}`;
};

// Convert dd/mm/yyyy to HTML date input format (yyyy-mm-dd)
export const convertDDMMYYYYToHTMLDate = (ddmmyyyy) => {
  if (!ddmmyyyy || ddmmyyyy === 'all') return '';
  
  const parts = ddmmyyyy.split('/');
  if (parts.length !== 3) return '';
  
  const day = parts[0];
  const month = parts[1];
  const year = parts[2];
  
  return `${year}-${month}-${day}`;
};